<template>
    <nav class="w-full flex flex-wrap justify-between items-center bg-torbay-primary-blue rounded-none">
        <div class=" w-full flex justify-between items-center py-4 px-2">
            <Logo></Logo>
        </div>
    </nav>
</template>
<script>
    import { default as Logo } from "./Logo.vue";

    export default {
        name: "TransactionalHeader",
        components: {
            Logo
        },
    };
</script>